<!-- 
    FORM VISUALIZACAO DA ORGANIZACAO
-->

<script>
import Vue from 'vue';
import { apiORDSpost, apiORDSdelete, apiDownloadPDF, apiEmailPDF } from '../shared/api-functions'
import { SysVars } from '../main';
import apiCrm from '../api/api-crm.js'

import CrmPipeline from './crm-pipeline'
import AgendaForm from '../forms/agenda-form'
import AnexosForm from '../components/anexos-form'
import CrmNegocioNovoForm from './crm-negocio-novo-form'
import CrmNegocioMotivoForm from './crm-negocio-motivo-form'
import CrmOrgNovoForm from './crm-org-novo-form'
import CrmPessoaNovoForm from './crm-pessoa-novo-form'
import CrmNegocioParticipantes from './crm-negocio-participantes'
import CrmNegocioSeguidores from './crm-negocio-seguidores'
import CrmNegocioAgenda from './crm-negocio-agenda'
import CrmNotes from './crm-notes'
import CrmEmail from './crm-email'
import CrmCard from './crm-card'

export default {
    props: {
        index: '',
    },

    components: {
        AgendaForm, AnexosForm, CrmPipeline, CrmNegocioNovoForm, CrmNegocioMotivoForm, CrmOrgNovoForm, 
        CrmEmail, CrmPessoaNovoForm, CrmNegocioParticipantes, CrmNegocioSeguidores, CrmNegocioAgenda, CrmCard,
        CrmNotes
    },

    data () {
        return {
            errmessages: null,
            error: false,
            metadata: this.$store.getters.getEntities.metadata,
            modalDelete: false,
            activeTab: 0,

            showFormNegocio: false,
            showFormOrg: false,
            showFormPessoa: false,

            codpessoa: null,

            organizacao: null,

            paramsNegocio: null,
            paramsPessoa: null,

            showVincularPessoa: false,

            anexos: [], //lista de anexos do pedido
            notes: [],
            addingNote: false,

            seguidores: [],
            showFormSeguidores: false,

            indexNote: null,
            texto: null,

            tabs: [
                { title: 'Detalhes', help: null, icon: 'fa-bars', count: 0 },
                { title: 'Arquivos', help: null, icon: 'fa-paperclip', count: 0 },
                // { title: null, help: 'E-mails', icon: 'fa-envelope', count: 0 },
                { title: 'Atividades Concluídas', help: null, icon: 'fa-calendar', count: 0 },
                { title: 'Negócios', help: null, icon: 'fa-dollar', count: 0 },
            ],

        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        permiteAlteracao: function () {
            return this.organizacao.excluido!='S'
        },

        tabDetalhes: function () {
            return this.activeTab=='0'
        },

        tabAnexos: function () {
            return this.activeTab=='1'
        },

        tabAgenda: function () {
            return this.activeTab=='2'
        },

        tabNegocios: function () {
            return this.activeTab=='3'
        },

        nomeUsuario: function () {
            if (this.organizacao && this.organizacao.usuario.length > 0)
              return this.organizacao.usuario[0].nome
            else 
              return null
        },

        tag: function () {
            if (this.organizacao && this.organizacao.tag.length > 0)
              return this.organizacao.tag[0]
            else 
              return null
        },

        agendaList: function () {
            return this.organizacao.agenda.filter((obj) => {
                return obj.concluida === 'S'
            })
        },

        agendaListPlanejada: function () {
            return this.organizacao.agenda.filter((obj) => {
                return obj.concluida != 'S'
            })
        },

        listNegocios: function () {
            if (this.organizacao.negocios)
                return this.organizacao.negocios
            else 
                return []
        },

        // emailList: function () {
        //     this.tabs[2].count = this.$store.getters.getNegocioEmails.length
        //     return this.$store.getters.getNegocioEmails
        // },

        administrador: function () {
            return SysVars.usuarioAdministrador
        },

    },

    methods: {
        changeTab (idx) {
            this.activeTab = idx
        },

        handleExcluir () {
            if (confirm("Confirma a exclusão?")) {
                this.apiOrgDelete(this.organizacao.codorg, this.callBackPost)
            }
        },

        handleReabrir () {
            let obj = { codorg: this.org.codorg, excluido: 'N' }
            this.apiOrg(obj, this.org.codorg, this.callBackPost)
        },

        callBackPost (org) {
            if (org)
              this.organizacao = org
        },

        handleStyle(color) {
            if (color)
              return 'color: white; background-color: ' + color;
            else 
              return ''
        },

        closeFormPessoa (pessoa) {
            this.showFormPessoa = false
            if (this.pessoa) {
                this.loadData()
            }
        },

        closeForm () {
            if (this.$route.params.id)
                this.$router.go(-1)
            else
                this.$emit('closeform')
        },

        loadEmails () {
            this.showCodemail = null
            this.$store.dispatch('loadNegocioEmails', { id: this.organizacao.codnegocio } )
        },

        async loadData () {
            await this.$store.dispatch('loadConfigCrm', this)
            let codorg = this.index
            if (this.$route.params && this.$route.params.id)
              codorg = this.$route.params.id
            await this.$store.dispatch('loadOrganizacao', { id: codorg } )
            if (this.$store.getters.getOrganizacao) {
                this.organizacao = {...this.$store.getters.getOrganizacao}
                this.notes = this.organizacao.notes
                this.seguidores = this.organizacao.seguidores
                this.anexos = this.organizacao.anexos
            }

            //CONTADORES
            this.tabs[1].count = this.anexos.length
            // this.tabs[2].count = this.emailList.length
            this.tabs[2].count = this.agendaList.length
            this.tabs[3].count = this.listNegocios.length

            this.$nextTick(() => document.getElementById('formorg').scrollIntoView({ behavior: "smooth" }))
        },

        handleCloseVincularPessoa () {
            this.loadData()
            this.showVincularPessoa = false
        },

        handleVincularPessoa (tipo) {
            this.showVincularPessoa = true
        },

        closeFormOrg (organizacao) {
            this.showFormOrg = false
            if (organizacao)
              this.organizacao = organizacao
        },


        //////////////////////////// ALTERAR OU VISUALIZAR NEGOCIO
        handleShowNegocio (codnegocio) {
          this.$router.push('/crm/negocio/' + codnegocio)
        },

        handleIncluirNegocio () {
            this.paramsNegocio = { organizacao: this.organizacao }
            this.showFormNegocio = true;
        },

        closeNovoNegocio (negocio) {
            this.showFormNegocio = false
            if (negocio)
              this.handleShowNegocio(negocio.codnegocio)
        },

        handleAdicionarAgendaNegocio (negocio) {
            //abre a tela de edicao
            // this.negociocrm = negocio
            // this.crud = SysVars.crudI 
            // this.codagenda = null
            // this.showFormAgenda = true;
        },

        handleEditAgendaNegocio (negocio, codagenda) {
            //abre a tela de edicao
            // this.negociocrm = negocio
            // this.crud = SysVars.crudU //operacao de edicao
            // this.codagenda = codagenda
            // this.showFormAgenda = true; //exibe o form de agenda
        },

        handleShowPessoa (codpessoa) {
          this.$router.push('/crm/pessoa/' + codpessoa)
        },

        handleEditarOrg () {
            this.showFormOrg = true
        },

        /////////////////////////////////// OBSERVACOES
        handleIncluirObs () {
            this.texto = null
            this.addingNote = true
        },
        handleEditObs (index) {
            this.$set(this.notes[index], 'editing', true)
            this.texto = this.notes[index].texto
        },
        handleDeleteObs (index) {
            if (confirm("Confirma a exclusão?")) {
                this.apiNotesDelete(this.notes[index].codnote).then(
                    this.notes.splice(index, 1)
                )
            }
        },
        handlePutObs (index) {
            if (!this.texto)
                return
            let note = this.notes[index]
            note.texto = this.texto
            this.indexNote = index
            this.apiNotes(note, note.codnote, this.callBackNote)
        },
        handlePostObs (texto) {
            if (!this.texto) {
                return
            }
            let note = { texto: this.texto, codorg: this.organizacao.codorg }
            this.apiNotes(note, null, this.callBackNote)
        },
        handleCancelObs (index) {
            if (index >= 0) 
                this.notes[index].editing = false
            else
                this.addingNote = false
        },
        callBackNote (data) {
            if (data) {
                if (this.addingNote) 
                    this.notes.push(data)
                else {
                    this.notes[this.indexNote].texto = data.texto
                    this.notes[this.indexNote].editing = false
                }
                this.addingNote = false
                this.indexNote = null
            }
        },
        /////////////////////////////////// FIM notes


        /////////////////////////////////// SEGUIDORES
        handleIncluirSeguidor () {
            this.showFormSeguidores = true
        },
        handleCloseSeguidor () {
            this.seguidores = this.organizacao.seguidores
            this.showFormSeguidores = false
        },
        /////////////////////////////////// FIM SEGUIDORES


        /////////////////////////////////// ATIVIDADES  / AGENDA
        handleIncluirAgenda (codagenda) {
            //abre a tela de edicao
            this.$refs.agenda.handleIncluirAgenda()
        },
        updateAgenda (agenda) {
            this.tabs[2].count = this.agendaList.length
        },
        /////////////////////////////////// FIM ATIVIDADES


        /////////////////////////////////// ANEXOS
        handleAnexarDocumento() {
            //ANEXAR DOCUMENTOS
            this.$nextTick(function () {
                this.$refs.anexos.handleClickAdiciona()
            })
        },
        handleChangeAnexos(anexosList) {
            //ATUALIZA A LISTA DE ANEXOS
            this.anexos = anexosList
            this.tabs[1].count = this.anexos.length
        },
        /////////////////////////////////// FIM ANEXOS


    },

    watch: {

    },

    mounted () {
        this.$nextTick(function () {
            if (this.$refs.usuario) {
               this.$refs.usuario.focus()
            }
        })
    },

    created () {
        this.loadData()
    }

}

</script>

<template>
<div id="formorg" class="deal-form" v-if="organizacao">
    <div class="deal-form-1">
        <div class="deal-form-2">
            <div class="deal-form-3">
                <div class="deal-form-left">
                    <div class="row">
                        <!-- NOME DA ORGANIZACAO -->
                        <div class="col-12 mt-2">
                            <span class="lbl-deal-title" style="cursor: pointer" @click="handleEditarOrg">{{ organizacao.nome}}</span>
                            <span v-if="organizacao.excluido=='S'" class="badge badge-red">Excluída</span>
                            <v-button v-if="organizacao.excluido!='S'" class="float-right" label="" title="Excluir esta organização" :danger="true" icon="fa-trash" @click="handleExcluir"></v-button>
                            <v-button v-if="organizacao.excluido!='S'" class="float-right" label="" title="" icon="fa-pencil" @click="handleEditarOrg"></v-button>
                            <v-button v-if="organizacao.excluido=='S'" class="float-right" label="Reabrir" title="Reabrir esta organização" icon="" @click="handleReabrir"></v-button>
                        </div>
                        <div class="col-12">
                            <div class="w-100">
                                <span class="lbl-list"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> Criado em {{ organizacao.data | formatDataHoraExtenso }}</span>
                            </div>
                            <div class="w-100">
                                <span class="lbl-list pr-3" v-if="organizacao.cnpj"> {{ organizacao.cnpj | formatCNPJCPF }} </span>
                            </div>
                            <div class="w-100">
                                <span class="lbl-list pr-3" v-if="organizacao.mun_nome"><i class="fa fa-location-arrow mr-2"></i> {{ organizacao.mun_nome }} {{ organizacao.uf }} </span>
                            </div>
                        </div>
                        <!-- ETIQUETA -->
                        <div class="col-12 mt-3" v-if="permiteAlteracao">
                            <div v-if="organizacao.tag.length>0">
                                <i class="lbl-deal-subtitle fa fa-tag pr-2" aria-hidden="true"></i> 
                                <span class="tag-input-color" :style="handleStyle(organizacao.tag[0].cor)" @click="handleEditarOrg">{{ organizacao.tag[0].descricao }} </span>
                            </div>
                            <v-button v-else :link="true" label="Definir uma etiqueta" icon="fa-tag" @click="handleEditarOrg"></v-button>
                        </div>
                        <div class="col-12 mt-5" v-if="organizacao.pessoas.length > 0">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle">CONTATOS VINCULADOS</span>
                            </div>
                            <span v-for="(pessoa, index) in organizacao.pessoas" :key="index">
                                <a class="data-list pr-2" :href="'#/crm/pessoa/' + pessoa.codpessoa"> <i class="fa fa-user pr-2" aria-hidden="true"></i> {{ pessoa.nome }} </a>
                            </span>
                        </div>
                        <div class="col-12 mt-5">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle mb-2">PROPRIETÁRIO</span>
                            </div>
                            <div>
                                <a class="lbl pr-2"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ nomeUsuario }}</a>
                            </div>
                        </div>
                        <div class="col-12 mt-5">
                            <span class="lbl-deal-subtitle">USUÁRIOS VINCULADOS</span>
                            <v-button v-if="permiteAlteracao" :link="true" label="Adicione usuários vinculados" icon="fa-plus" :nb-btdef="false" @click="handleIncluirSeguidor"></v-button>
                            <span v-for="(item, index) in seguidores" :key="index">
                                    <a class="data-list pr-2"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ item.usuario_nome }}</a>
                            </span>
                        </div>

                        <div class="col-12 mt-5">
                            <span class="lbl-deal-subtitle"><i class="fa fa-paperclip pr-2"></i>ANEXOS</span>
                            <v-button v-if="permiteAlteracao" :link="true" label="Anexar um Arquivo" icon="fa-plus" :nb-btdef="false" @click="handleAnexarDocumento"></v-button>
                            <div class="mt-3">
                                <anexos-form ref="anexos" :params="{ ref: 'orgcrm', chaveref: organizacao.codorganizacao, showForm: false }" @change="handleChangeAnexos"></anexos-form>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="deal-form-right">
                    <div class="sticky">
                        <button type="button" class="close" style="" @click="closeForm()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div style="overflow-x: auto; height: 100%;">
                        <div class="mt-1">
                            <crm-notes :params="{ codorg: organizacao.codorganizacao, notes: notes }"></crm-notes>
                        </div>
                        <div class="mt-5">
                            <span class="lbl-deal-subtitle mb-2"><i class="fa fa-calendar pr-2"></i>ATIVIDADES PLANEJADAS</span>
                            <v-button :link="true" label="Criar uma atividade" icon="fa-plus" @click="handleIncluirAgenda"></v-button>
                        </div>
                        <crm-negocio-agenda ref="agenda" 
                            :params="{ organizacao: organizacao, pessoa: null, listAgenda: organizacao.agenda, listAgendaShow: agendaListPlanejada, delete: true, edit: true }"
                            @update="updateAgenda" @delete="updateAgenda"></crm-negocio-agenda>
                        <div class="mt-5" v-if="listNegocios.length > 0">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle"><i class="fa fa-dollar pr-2"></i>NEGÓCIOS</span>
                            </div>
                        </div>
                        <div v-for="(negocio, index) in listNegocios" :key="index">
                            <crm-card :negocio="negocio"
                                @edit="handleShowNegocio(negocio.codnegocio)" @adicionarAgenda="handleAdicionarAgendaNegocio" @editAgenda="handleEditAgendaNegocio"></crm-card>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <crm-negocio-novo-form v-if="showFormNegocio" :params="paramsNegocio" @closeform="closeNovoNegocio"></crm-negocio-novo-form>
    <crm-org-novo-form v-if="showFormOrg" :index="organizacao.codorg" @closeform="closeFormOrg"></crm-org-novo-form>
    <crm-pessoa-novo-form v-if="showFormPessoa" :index="this.codpessoa" @closeform="closeFormPessoa"></crm-pessoa-novo-form>
    <crm-negocio-seguidores v-if="showFormSeguidores" :params="{ organizacao: organizacao }" @closeform="handleCloseSeguidor"></crm-negocio-seguidores>

</div>

</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-org-form.vue